'use strict';
module.exports = require('./TabPanel.vue');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/tabpanel/index.js
// module id = 382
// module chunks = 1